import {SET_PENDING_TRANSACTIONS, SET_LOADING, SET_MULTIPLE_PENDING_TRANSACTIONS} from '../../types';
import { sendTx, createClient } from '../../helpers/bc';
import {getWallet} from '../../helpers/wallet';

import {
  createUnlockTakerTx
} from 'bc-sdk/dist/transaction'

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function unlockCollateral({ password, txData}, done){
  return async function(dispatch,getState) {
    try {
      // dispatch({type:SET_LOADING,payload:true})
      const state = getState()
      const bcClient = createClient(state.settings.settings)

      //BUILD TXS
      let txs = [];
      let pending = [];
      done(null);

      for(let i = 0; i < txData.length ; i++) {
        let {txHash,txOutputIndex,address,amount} = txData[i];
        let { privateKey: bcPrivateKeyHex} = getWallet(getState,address, 'nrg', password)
        let tx = await createUnlockTakerTx(txHash, txOutputIndex, address.toString(), bcPrivateKeyHex.toString(), bcClient);
        let data = await sendTx(state.settings.settings,tx);

        if(data.txHash && data.txHash.length > 4){
          pending.push({hash:data.txHash,type:"Unlock Collateral",txHash,txOutputIndex,chain:"NRG",amount,from:address,to:'Tx Pending Pool'});
        }
        dispatch({type:SET_MULTIPLE_PENDING_TRANSACTIONS,payload: [{hash:data.txHash,type:"Unlock Collateral",txHash,txOutputIndex,chain:"NRG",amount,from:address,to:'Tx Pending Pool'}]});

        await timeout(100)
      }

      // dispatch({type:SET_MULTIPLE_PENDING_TRANSACTIONS,payload: pending});
      // dispatch({type:SET_LOADING,payload:false})

      // done(null,pending);
    }
    catch(err){
      dispatch({type:SET_LOADING,payload:false})
      console.log({err})
      done(err)
    }
  }
}
